import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { Emphasis, Placement, Tooltip } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { AskAiSourceChip } from '../AskAiSourceChip/AskAiSourceChip';

interface AskAiSourceListMoreChipProps {
    /** number of sources that remains to display */
    remainingSourcesCount: string;
    /** set state for displaying or not the extra sources */
    setDisplayExtraSources: React.Dispatch<React.SetStateAction<boolean>>;
    /** Additional classname that can be pass to the component */
    className?: string;
}

const CLASSNAME = 'ask-ai-source-list-more-chip';

/**
 * Component used for displaying the number of additional sources that can be displayed in AskAi
 * @param AskAiSourceListMoreChipProps
 * @returns a list item that includes a chip or a button labeled with the number of additional sources that can be displayed
 */
export const AskAiSourceListMoreChip = ({
    remainingSourcesCount,
    setDisplayExtraSources,
    className,
}: AskAiSourceListMoreChipProps) => {
    const { block } = useClassnames(CLASSNAME);
    const { translateAndReplace } = useTranslate();

    const label = `+ ${remainingSourcesCount}`;

    const handleClick = () => setDisplayExtraSources(true);

    return (
        <li className={block(undefined, [className])}>
            <Tooltip
                label={translateAndReplace(GLOBAL.SEE_MORE_NB_ITEMS, { COUNT: remainingSourcesCount })}
                placement={Placement.TOP}
            >
                <AskAiSourceChip emphasis={Emphasis.low} onClick={handleClick}>
                    {label}
                </AskAiSourceChip>
            </Tooltip>
        </li>
    );
};
